import { render, staticRenderFns } from "./PosRelease.vue?vue&type=template&id=2ae3c9c4&"
import script from "./PosRelease.vue?vue&type=script&lang=js&"
export * from "./PosRelease.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports